<template>
  <SeoPage page-key="campagnePubblicitarieOnlineTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'CampagnePubblicitarieOnlineTicinoPage'
})
</script>

